const Category = [
    {
        "_id": 1,
        "name": "Agriculture"
    },
    {
        "_id": 2,
        "name": "Art"
    },
    {
        "_id": 3,
        "name": "Buisness to Buisness"
    },
    {
        "_id": 4,
        "name": "Design"
    },
    {
        "_id": 5,
        "name": "E-commerce"
    },
    {
        "_id": 6,
        "name": "Engineering"
    }
   
]


export {Category}
